// // 📁 Imports
// data-menu-status
// // 💾 Variables
const menuStatus = document.querySelector("[data-menu-status]");
const openMenuTrigger = document.querySelectorAll("[data-menu-trigger-open]");
const closeMenuTrigger = document.querySelectorAll("[data-menu-trigger-close]");

// // 📐 Functions
const openMenu = () => {
  if (menuStatus) {
    menuStatus.dataset.menuStatus = "open";
  }
};

const closeMenu = () => {
  if (menuStatus) {
    menuStatus.dataset.menuStatus = "close";
  }
};

// // 🖱️ Event listener
if (openMenuTrigger.length !== 0) {
  Array.from(openMenuTrigger).forEach((triggerEl) => {
    triggerEl.addEventListener("click", () => {
      openMenu();
    });
  });
}

if (closeMenuTrigger.length !== 0) {
  Array.from(closeMenuTrigger).forEach((triggerEl) => {
    triggerEl.addEventListener("click", () => {
      closeMenu();
    });
  });
}

// // 📤 Export
export { openMenu, closeMenu };
